import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1618.693 -4099)">
      <circle
        cx="15"
        cy="15"
        r="15"
        transform="translate(-1617.943 4099.75)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M38.038,8.256A14.983,14.983,0,0,0,25.058.75v15Z"
        transform="translate(-1628 4099)"
        fill={color}
      />
    </g>
  </svg>
);
